// extracted by mini-css-extract-plugin
module.exports = {"purpleHighlight":"BalanceItem_purpleHighlight__2YZFz","balanceContainer":"BalanceItem_balanceContainer__2UsxP","network":"BalanceItem_network__1bu1c"};